export const unitFaq = {
  head: {
    title: "Perguntas e respostas da unidade",
    chip: "IA",
    subPre: "Respostas específicas para",
    subStrong: "esta unidade",
    subPost: ". O agente as usará primeiro ao ajudar um hóspede hospedado aqui (ex.: o código da porta, particularidades deste apartamento…). Anexe imagens ou vídeos e o agente os enviará sempre que o hóspede precisar.",
  },
  clone: {
    titleNoun: "FAQs",
    itemNoun: "as FAQs",
    buttonLabel: "Clonar perguntas",
  },

  copyOne: {
    title: "Copiar esta pergunta",
    itemNoun: "pergunta",
  },
  loading: "Carregando…",
  emptyList: "Nenhuma pergunta ainda. Adicione a primeira para que o agente saiba como respondê-la.",
  list: {
    newQuestion: "Nova pergunta",
    attachments: "{count} anexo | {count} anexos",
    learnedTitle: "Adicionada por autoaprendizado",
    deleteTitle: "Excluir",
    copyTitle: "Copiar para outras unidades",
  },
  form: {
    questionLabel: "Pergunta",
    answerLabel: "Resposta do agente",
    qPlaceholder: "Pergunta · ex.: Qual é o código da porta?",
    aPlaceholder: "Resposta · ex.: O código de entrada do seu prédio é 4512.",
    removeAttachment: "Remover anexo",
    uploading: "Enviando…",
    attach: "Anexar",
    addQuestion: "Adicionar pergunta",
  },
  preview: {
    tag: "Prévia · WhatsApp",
    online: "online",
    aiReception: "Recepção com IA",
    questionPlaceholder: "Digite a pergunta do hóspede…",
    answerPlaceholder: "Digite a resposta que o agente dará…",
    videoFile: "Vídeo",
    genericFile: "Arquivo",
    empty: "Selecione ou crie uma pergunta para ver como o agente responderá.",
    hint: "É assim que o hóspede verá no chat",
  },
  footer: {
    saved: "Salvo",
    save: "Salvar alterações",
  },
  errors: {
    load: "Não foi possível carregar as perguntas.",
    attachNeedsQA: "Escreva a pergunta e a resposta antes de anexar arquivos.",
    attachNeedsSave: "Salve primeiro para poder anexar arquivos.",
    upload: "Não foi possível enviar o arquivo.",
    deleteFile: "Não foi possível excluir o arquivo.",
    save: "Não foi possível salvar.",
  },
};
